module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-ui column default-form-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\tDocuments liés à l'abonnement\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-docs row"
  }, [_c('div', {
    staticClass: "ctn-doc"
  }, [_c('div', {
    staticClass: "tile-doc row"
  }, [_c('span', {
    staticClass: "icon-document-pdf"
  }), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\t\tContrat d'abonnement\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s((_vm.subscriptionContract) ? _vm.subscriptionContract.original_name : 'Pas de fichier') + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "id": "lmfile",
      "type": "file"
    },
    on: {
      "change": _vm.uploadSubscriptionContractFile
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ctn-actions row"
  }, [(_vm.needForSign(_vm.subscriptionContract)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    class: {
      'btn-disabled': !_vm.hasIdentityCertificated
    },
    on: {
      "click": function($event) {
        return _vm.askForSignature(_vm.subscriptionContract)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tSoumettre une signature\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.canLoad(_vm.subscriptionContract)) ? _c('div', {
    staticClass: "btn btn-red ctn-icon",
    on: {
      "click": function($event) {
        return _vm.procUpload('lmfile')
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v("\n\t\t\t\t\tCharger un fichier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.subscriptionContract && !_vm.needForSign(_vm.subscriptionContract) && _vm.subscriptionContract.universign_launch_date) ? _c('div', {
    staticClass: "status row"
  }, [_vm._v("\n\t\t\t\t\tAjouté le " + _vm._s(_vm.subscriptionContract.universign_launch_date.split(' ')[0]) + "\n\t\t\t\t\t"), (_vm.subscriptionContract.universign_status === 'completed') ? _c('span', {
    staticClass: "green inner-status"
  }, [_vm._v("Signé le " + _vm._s(_vm.subscriptionContract.signature_date.split(' ')[0]))]) : _vm._e(), _vm._v(" "), (_vm.subscriptionContract.universign_status === 'ready') ? _c('span', {
    staticClass: "orange inner-status"
  }, [_vm._v("Signature en attente")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasIdentityCertificated),
      expression: "!hasIdentityCertificated"
    }],
    staticClass: "text-red"
  }, [_c('br'), _c('small', [_c('i', {
    staticClass: "icon-bandeau-alert"
  }), _vm._v(" L'identité du client doit être vérifiée avant de lui soumettre une signature.\n\t\t\t\t\t\t"), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.subscription.user.id
        }
      }
    }
  }, [_vm._v("Vérifier son identité")])], 1)]), _vm._v(" "), (_vm.subscriptionContract) ? _c('div', {
    staticClass: "other-actions row"
  }, [(_vm.subscriptionContract.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.callVerify(_vm.subscriptionContract)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tVérifier\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.subscriptionContract.universign_status === 'ready') ? _c('div', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.relaunchTransaction(_vm.subscriptionContract)
      }
    }
  }, [_vm._v("\n\t\t\t\t\tEnvoyer un mail de relance\n\t\t\t\t")]) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc69824a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MySubscriptions/EditForm/Docs.vue
// module id = 1172
// module chunks = 0